export const FETCH_SKILLS = "FETCH_SKILLS";
export const FETCH_SKILLS_START = "FETCH_SKILLS_START";
export const FETCH_SKILLS_SUCCESS = "FETCH_SKILLS_SUCCESS";
export const FETCH_SKILLS_ERROR = "FETCH_SKILLS_ERROR";

export const fetchSkills = () => {
    return {
        type: FETCH_SKILLS,
    };
};